interface TagChipProps {
  label: string;
  state: 'display' | 'selected' | 'unselected';
  onClick?: () => void;
}

export function TagChip({ label, state, onClick }: TagChipProps) {
  if (state === 'display') {
    return (
      <span
        data-state={state}
        className="bg-bark-700 rounded-sm px-2 py-1 text-body-xs text-bark-100"
      >
        {label}
      </span>
    );
  }

  const selectedClass =
    'bg-ember-900/40 text-ember-400 border-[0.5px] border-ember-700/50 rounded-sm px-2 py-1 text-body-xs';
  const unselectedClass =
    'bg-transparent rounded-sm px-2 py-1 text-body-xs border-[0.5px] border-bark-600 text-bark-300';

  return (
    <button
      type="button"
      data-state={state}
      data-touch-target="true"
      onClick={onClick}
      className={`flex items-center justify-center min-h-[44px] min-w-[44px] ${
        state === 'selected' ? selectedClass : unselectedClass
      }`}
    >
      {label}
    </button>
  );
}
